import { render, staticRenderFns } from "./DocumentTemplateEditForm.vue?vue&type=template&id=d961bcb0"
import script from "./DocumentTemplateEditForm.vue?vue&type=script&lang=js"
export * from "./DocumentTemplateEditForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports